wbApp.factory('itemTypeSvc', ['$resource', '$q','repositorySvc',
    function ($resource, $q, repositorySvc) {

        var ItemType = $resource('/restapi/item-types/:id', {}, {
            'getById': { method: 'GET', url: '/restapi/item-types/:id' },
            'getAll': { method: 'GET', isArray: true, url: '/restapi/item-types' },
            'getByPlaceAndRentCategory': { method: 'GET', isArray: true, url: '/restapi/item-types/find-by-place-and-rent-category' },
            'insert': { method: 'POST', url: '/restapi/item-types' },
            'update': { method: 'PUT', url: '/restapi/item-types/:id' },
            'delete': { method: 'DELETE', url: '/restapi/item-types/:id' },
        });

        var itemTypes;

        function createNew()
        {
            var itemType = {
                isNew: true
            };

            return itemType;
        }

        function insert(model) {
            return repositorySvc.customPost(
                'insert',
                ItemType,
                model);
        }

        function remove(itemTypeId) {
            itemTypes = null;
            return repositorySvc.customDelete(
                'delete',
                ItemType,
                { id: itemTypeId });
        }

        function update(model) {
            itemTypes = null;
            return repositorySvc.customPutWithParams(
                'update',
                ItemType,
                { id: model.id },
                convertDatesToDateString(model));
        }

        function getById(itemTypeId) {
            return repositorySvc.customGet('getById', ItemType, { id: itemTypeId });
        }

        function getAll(refresh) {
            if (!itemTypes || refresh) {
                itemTypes = repositorySvc.customGet('getAll', ItemType, {});
            }
            return itemTypes;
        }

        function getByPlaceAndRentCategory(placeId, rentCategoryId) {
            return repositorySvc.customGet('getByPlaceAndRentCategory', ItemType, { placeId: placeId, rentCategoryId: rentCategoryId });
        }

        return {
            createNew: createNew,
            getById: getById,
            getAll: getAll,
            getByPlaceAndRentCategory: getByPlaceAndRentCategory,
            insert: insert,
            remove: remove,
            update: update,
        }
    }
]);